import { Category } from '@common/category';

export interface AdminCategoriesState {
  categories: Category[];
  totalElements: number;
  totalPages: number;
  currentPage: number;
  isLoading: boolean;
  error: any;
}

export const initialState: AdminCategoriesState = {
  categories: [],
  totalElements: 0,
  totalPages: 0,
  currentPage: 0,
  isLoading: false,
  error: null
};
